export const UserAgentDetection = {
  Android: function (userAgent: string) {
    return userAgent.match(/Android/i);
  },
  BlackBerry: function (userAgent: string) {
    return userAgent.match(/BlackBerry/i);
  },
  iOS: function (userAgent: string) {
    return userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera: function (userAgent: string) {
    return userAgent.match(/Opera Mini/i);
  },
  Windows: function (userAgent: string) {
    return userAgent.match(/IEMobile/i) || userAgent.match(/WPDesktop/i);
  },
  isMobileUserAgent: function (userAgent: string | string[]) {
    if (typeof userAgent !== 'string') {
      userAgent = userAgent.join();
    }
    if (!userAgent) {
      return false;
    }
    return (
      UserAgentDetection.Android(userAgent) ||
      UserAgentDetection.BlackBerry(userAgent) ||
      UserAgentDetection.iOS(userAgent) ||
      UserAgentDetection.Opera(userAgent) ||
      UserAgentDetection.Windows(userAgent)
    );
  },
};
